<div class="loader-wrapper" [class.loader-overlay]="overlay">
  <div class="loader-content">
    <!-- Spinner ring -->
    <div class="spinner" [ngClass]="'spinner-' + size">
      <svg viewBox="0 0 50 50">
        <circle class="track"  cx="25" cy="25" r="20" />
        <circle class="arc"    cx="25" cy="25" r="20" />
      </svg>
      <div class="pulse-dot"></div>
    </div>

    <!-- Optional message -->
    <p class="loader-message" *ngIf="message">{{ message }}</p>
  </div>
</div>
